import { Box, Typography } from "@mui/material";
import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch, useSelector } from "react-redux";
import { deleteFile, downloadAttachment } from "../customerGroupSetupSlice";

export default function CreateAttachments() {
   const dispatch = useDispatch();
   const cgState = useSelector((store) => store.customerGroupSetup);
   const { files } = cgState;

   function handleDeleteFile(file) {
      console.log(file);
      dispatch(deleteFile(file));
   }

   function handleDownloadFile(file) {
      console.log(file);
      dispatch(downloadAttachment({ fileName: file.name ? file.name : file.filePath }));
   }

   return (
      <Box sx={{ mt: 2 }}>
         {" "}
         <Box
            sx={{
               height: "auto",
               pt: 1.4,
               pl: 1,
               boxShadow: "0px 2px #E4EAF2",
               mt: -8,
            }}
         >
            <Typography sx={{ fontWeight: "bold", mb: 3 }}>
               Attachments
            </Typography>{" "}
            <List dense={false}>
               {files.map((file, index) => {
                  return (
                     <ListItem
                        key={index}
                        secondaryAction={
                           <>
                              <IconButton
                                 edge="end"
                                 aria-label="delete"
                                 onClick={() => handleDownloadFile(file)}
                                 sx={{ mr: 2 }}
                              >
                                 <DownloadRoundedIcon />
                              </IconButton>
                              <IconButton
                                 edge="end"
                                 aria-label="delete"
                                 onClick={() => handleDeleteFile(file)}
                              >
                                 <DeleteIcon />
                              </IconButton>
                           </>
                        }
                     >
                        <ListItemAvatar>
                           <Avatar sx={{ bgcolor: "blue.main" }}>
                              <InsertDriveFileIcon
                                 sx={{ color: "blue.light" }}
                              />
                           </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                           primary={file.filePath ? file.filePath : file.name}
                           secondary={false ? "Secondary text" : null}
                        />
                     </ListItem>
                  );
               })}
            </List>
         </Box>
      </Box>
   );
}
